<template>
  <div class="columns is-gapless is-border-bottom" v-if="membre">
    <div class="column is-narrow is-flex is-padding-small tooltip is-tooltip-left"
      :class="isCheck ? 'has-bg-success' : bgFalse"
      :data-tooltip="isCheck ? 'Fiche complète' : 'Fiche incomplète'">
      <span class="icon has-text-white is-self-centered"
      :class="isCheck ? 'has-text-white' : textFalse"><i
        :class="isCheck ? 'fa-check-circle' : 'fa-exclamation-circle'" class="fas"></i></span>
    </div>
    <div class="column columns is-padding-small is-gapless is-multiline">
      <div class="column is-6 is-4-widescreen is-4-fullhd is-padding-xxsmall">
        <div class="label">
          <span class="is-uppercase" v-if="isPromoteur">RÉSERVANT / PROMOTEUR</span>
          <span class="is-uppercase" v-else-if='isCoAcquereur'>RÉSERVATAIRE / CO-Acquéreur</span>
          <span class="is-uppercase" v-else>RÉSERVATAIRE / Acquéreur</span>
        </div>
        <div class="title is-5 has-text-weight-medium">
          <div v-if="isPromoteur" class="title is-5 has-text-weight-medium">
            <div class="is-uppercase">{{membre.company_name || 'NC'}}</div>
            <div class="is-uppercase" v-if="membre.first_name && membre.last_name">{{membre.last_name}} <span style="text-transform: capitalize">{{membre.first_name}}</span></div>
          </div>
          <div v-else class="title is-5 has-text-weight-medium">
            <div class="is-uppercase" v-if="'nature' in membre && membre.nature && membre.nature === 'corporation'">{{membre.corporation_name}}</div>
            <div class="is-uppercase" v-if="membre.first_name && membre.last_name">{{membre.last_name}} <span style="text-transform: capitalize">{{membre.first_name}}</span></div>
          </div>
        </div>
      </div>
      <div class="column is-6 is-4-widescreen is-4-fullhd is-padding-xxsmall">
        <div class="label">
          <span>Adresse</span>
        </div>
        <div class="title is-5 has-text-weight-medium"
              v-if="membre && membre.address">
          <span v-if="membre.address.line1">{{membre.address.line1}}</span>
          <br v-if="membre.address.line1">
          <span v-if="membre.address.zip_code || membre.address.city">{{membre.address.zip_code}} {{membre.address.city}}</span>
          <br v-if="membre.address.zip_code || membre.address.city">
          <span v-if="membre.address.country">{{membre.address.country}}</span>
          <span v-if="!membre.address.line1 && !membre.address.zip_code &&
                      !membre.address.country && !membre.address.city">
            NC
          </span>
        </div>
      </div>
      <div class="column is-12 is-4-widescreen is-4-fullhd columns is-gapless is-multiline">
        <div class="column is-6 is-12-widescreen is-12-fullhd is-padding-xxsmall">
          <div class="label">
            <span>Téléphone</span>
          </div>
          <div class="title is-5 has-text-weight-medium">
            {{membre.phone || 'NC'}}
          </div>
        </div>
        <div class="column is-6 is-12-widescreen is-12-fullhd is-padding-xxsmall">
          <div class="label">
            <span>Mail</span>
          </div>
          <div class="title is-5 has-text-weight-medium">
            <span>{{membre.email || 'NC'}}</span>
          </div>
        </div>
      </div>
    </div>
    <template v-if="hasButton">
      <div v-if="isPromoteur && modalPromoteur" class="actionsOnRow actionsOnRow--vertical">
        <div class="is-min-height-full">
          <button @click="openModalPromoteurInfo()" class="tooltip is-tooltip-left"
                  data-tooltip="Modifier coordonnées promoteur">
            <span class="icon"><i class="fal fa-file-edit"></i></span>
          </button>
        </div>
      </div>
      <div v-else-if="fromResa" :class="{'actionsOnRow actionsOnRow--vertical' : isCoAcquereur}">
        <div v-if="isCoAcquereur" class="">
          <button @click="DeleteCobuyer(membre)" class="tooltip is-tooltip-left is-tooltip-danger"
                  data-tooltip="Supprimer le co-acquéreur">
            <span class="icon"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
      <div v-else class="actionsOnRow actionsOnRow--vertical">
        <div class="">
          <button @click="goToContact(membre.pk)" class="tooltip is-tooltip-left"
                  data-tooltip="Modifier fiche contact">
            <span class="icon"><i class="fal fa-file-edit"></i></span>
          </button>
        </div>
        <div v-if="isCoAcquereur" class="">
          <button @click="DeleteCobuyer(membre)" class="tooltip is-tooltip-left is-tooltip-danger"
                  data-tooltip="Supprimer le co-acquéreur">
            <span class="icon"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MembreAdv',
  props: {
    isCheck: Boolean,
    membre: Object,
    isPromoteur: Boolean,
    isCoAcquereur: Boolean,
    modalPromoteur: Boolean,
    hasButton: {
      type: Boolean,
      default: true
    },
    isGrey: {
      type: Boolean,
      default: false
    },
    fromResa: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isSeller', 'isExternal']),
    bgFalse () {
      if (this.isGrey) {
        return 'has-bg-grey3'
      } else {
        return 'has-bg-danger'
      }
    },
    textFalse () {
      if (this.isGrey) {
        return 'has-text-danger'
      } else {
        return 'has-text-white'
      }
    }
  },
  methods: {
    openModalPromoteurInfo () {
      this.$emit('openModalPromoteurInfo')
    },
    goToContact (membrePk) {
      this.$emit('goToContact', membrePk)
    },
    DeleteCobuyer (membre) {
      this.$emit('DeleteCobuyer', membre)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/adv/MembreAdv.vue